<div class="joystick-ngx">
  <div class="container noselect" *ngIf="init">
    <div class="zone" #zone id="zone">
      <!-- <ngx-joystick #staticJoystic [options]="staticOptions" (start)="onStartStatic($event)" (end)="onEndStatic($event)"
        (move)="onMoveStatic($event)" (plainUp)="onPlainUpStatic($event)" (plainDown)="onPlainDownStatic($event)"
        (plainLeft)="onPlainLeftStatic($event)" (plainRight)="onPlainRightStatic($event)"></ngx-joystick> -->
    </div>
  </div>
</div>